module.exports = __webpack_public_path__ + "static/img/half_pitch_green.7a68f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half_pitch_green.png
// module id = EdVJ
// module chunks = 94